module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-ties-remnants.feddaf40.png";